import { render, staticRenderFns } from "./presenceChanges.vue?vue&type=template&id=93976ea0&"
import script from "./presenceChanges.vue?vue&type=script&lang=js&"
export * from "./presenceChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports